export default "__VITE_ASSET__BJhD8vBI__"